import { colors } from 'ui/theme';
import {
  PREVIEW_USERS_USER,
  PREVIEW_USERS_USERS,
  PREVIEW_USERS_NO_USERS,
  PREVIEW_USERS_ONLY,
  PREVIEW_USERS_APPROX,
} from 'modules/predictiveGoals/constants';
import { formatPreviewUsersCount } from '../../goalUtils';

export const countMeetsRequirement = (usersCount: number) => usersCount >= 1000;

export const interpretCountStyle = (reqMet: boolean) =>
  reqMet ? colors.green100 : colors.warning100;

export const getPreviewUsersLeadingText = (usersCount: number) => {
  if (usersCount <= 0) {
    return '';
  } else if (usersCount >= 1 && usersCount < 1000) {
    return PREVIEW_USERS_ONLY;
  } else {
    return PREVIEW_USERS_APPROX;
  }
};

export const getPreviewUsersCountText = (usersCount: number) => {
  if (usersCount <= 0) {
    return PREVIEW_USERS_NO_USERS;
  } else if (usersCount === 1) {
    return `${formatPreviewUsersCount(usersCount)} ${PREVIEW_USERS_USER}`;
  } else {
    return `${formatPreviewUsersCount(usersCount)} ${PREVIEW_USERS_USERS}`;
  }
};
